/* eslint eqeqeq: 0 */
const UID_PATTERN = /^[A-Z0-9]{28,36}$/;

/**
 * Check if `healthcareUser` (uid) is valid.
 *
 * @param  {String} uid - Healthcare User ID.
 * @return {Boolean}
 */
function isValidUID(uid) {
  return uid && UID_PATTERN.test(uid);
}

/**
 * Gets the `healthcareUser` (uid) from URL or cookies.
 *
 * @param  {String} uidFromUrl - Healthcare User ID from URL.
 * @param  {String} uidFromCookie - Healthcare User ID from cookie.
 * @return {String}
 */
export function getHealthcareUser(uidFromUrl, uidFromCookie) {
  if (isValidUID(uidFromUrl)) return uidFromUrl;
  if (uidFromCookie) return uidFromCookie;
  return '';
}

/**
 * Check if `healthcareUser` (uid) is in the URL and validate if it should generate a new session.
 *
 * @param  {String} uidFromUrl - Healthcare User ID from URL.
 * @param  {String} uidFromCookie - Healthcare User ID from cookie.
 * @return {Boolean}
 */
export function shouldGenerateHealthcareUser(uidFromUrl, uidFromCookie) {
  if (isValidUID(uidFromUrl) && (uidFromCookie != uidFromUrl)) return true;
  return !uidFromCookie;
}
